import { gql, useMutation } from "@apollo/client";

import { ME_GET_USER_INFO } from "~/modules/auth/api/useMeGetUserInfoQuery";

const USER_IMPORT_START = gql(`
    mutation UserImportStart($input: GqlUserStartImportInput!) {
        userImportStart(input: $input) {
            id
            worker
            status
        }
    }
`);

export default function useUserImportStart() {
    const [startUserImportJob, { data, loading, error }] = useMutation(USER_IMPORT_START, {
        refetchQueries: [ME_GET_USER_INFO],
    });

    return {
        startUserImportJob: (mediaId: string) =>
            startUserImportJob({
                variables: {
                    input: {
                        mediaId,
                    },
                },
            }),
        loading,
        error,
        data: data?.userImportStart,
    };
}
